// extracted by mini-css-extract-plugin
export var copyrightData = "footer-module--copyrightData--SAJW7";
export var copyrightSection = "footer-module--copyrightSection--khZeW";
export var copyrights = "footer-module--copyrights--VnAjs";
export var desktopLogo = "footer-module--desktopLogo--9BIcI";
export var facultyCourseLinks = "footer-module--facultyCourseLinks--ztstM";
export var facultyLinksPartitions = "footer-module--facultyLinksPartitions--m7wJd";
export var footer = "footer-module--footer--zWWiV";
export var footerCompanyDetails = "footer-module--footerCompanyDetails--aIRz2";
export var footerData = "footer-module--footerData--T9cCW";
export var footerFacultyLinks = "footer-module--footerFacultyLinks--JwqOy";
export var footerHorizontalLine = "footer-module--footerHorizontalLine--7qekY";
export var footerLogo = "footer-module--footerLogo--5CQ5z";
export var footerLogoTagline = "footer-module--footerLogoTagline--faXzU";
export var footerPageLinks = "footer-module--footerPageLinks---JsKo";
export var footerSlogan = "footer-module--footerSlogan--QIp0I";
export var hideOnMobile = "footer-module--hideOnMobile--TUIGP";
export var languageSection = "footer-module--languageSection--w-UE+";
export var mediaLinks = "footer-module--mediaLinks--udkLs";
export var mobileLogo = "footer-module--mobileLogo--Hr9hX";
export var policyLinks = "footer-module--policyLinks--SwKDT";
export var sectionHeader = "footer-module--sectionHeader--Cqm4f";
export var shawBtn = "footer-module--shawBtn--7WKLC";
export var showOnMobile = "footer-module--showOnMobile--emX3W";
export var socialIcons = "footer-module--socialIcons--pZvNB";
export var socialLinks = "footer-module--socialLinks--uDPPh";